<template>
  <v-card v-if="inclusionItem">
    <v-toolbar dense card>
      <div class="text-lg-left beez-bold ">
        Inclusion :
        {{ inclusionItem.selectedType }}
      </div>
      <v-spacer />
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          color="secondary"
          @click="handleCRONCompute"
        >
          <v-icon>check_circle</v-icon>
        </v-btn>
        <span>Commit</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn flat slot="activator" icon @click="handleInclusionItemDelete">
          <v-icon>delete</v-icon>
        </v-btn>
        <span>Delete</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-layout class="row wrap">
        <v-flex xs12 d-flex>
          <v-flex xs12 sm6>
            <v-select
              attach
              :items="item.inclusionTypes"
              v-model="inclusionItem.selectedType"
              item-text="type"
              item-value="type"
              label="Select Inclusion Types"
              outline
              :change="inclusionTypeChanged(inclusionItem)"
              style="padding-right: 10px;"
            />
          </v-flex>
          <v-flex xs12 sm6 v-if="inclusionItem.selectedType">
            <v-autocomplete
              attach
              :items="item.options"
              v-model="inclusionItem.selectedOption"
              item-text="name"
              item-value="name"
              label="Select Option"
              outline
            />
          </v-flex>
        </v-flex>
      </v-layout>
      <v-layout class="row wrap">
        <v-flex xs12 d-flex>
          <v-flex xs12 sm6 v-if="inclusionItem.selectedOption === 'Every'">
            <v-radio-group v-model="inclusionItem.specialValue" column>
              <v-radio label="* - all values" value="*" color="secondary" />
              <v-radio
                label="? - no specific value"
                value="?"
                color="secondary"
                v-if="
                  inclusionItem.selectedType === 'Day of month' ||
                    inclusionItem.selectedType === 'Day of week'
                "
              />
              <v-radio
                label="Select from possible values"
                value="default"
                color="secondary"
              />
            </v-radio-group>
          </v-flex>
          <v-flex
            xs12
            sm6
            v-if="
              inclusionItem.selectedOption === 'Every' &&
                inclusionItem.specialValue === 'default'
            "
          >
            <v-autocomplete
              attach
              :items="item.values"
              v-model="inclusionItem.value1"
              label="Select Value"
              outline
              box
              chips
              multiple
              :change="selectionSingleChanged(inclusionItem)"
            >
              <v-list-tile
                slot="prepend-item"
                ripple
                @click="selectAll(inclusionItem)"
              >
                <v-list-tile-action>
                  <v-icon :color="inclusionItem.value1 > 0 ? '#ff6f00' : ''"
                    >{{ inclusionItem.selectIcon }}
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  Select All
                </v-list-tile-title>
              </v-list-tile>
              <v-divider slot="prepend-item" class="mt-2"></v-divider>
              <template slot="selection" slot-scope="{ item, index }">
                <v-chip v-if="index <= 5">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index === 5" class="grey--text caption"
                  >(+{{ inclusionItem.value1.length - 6 }} others)</span
                >
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 v-if="inclusionItem.selectedOption === 'Range'">
            <v-autocomplete
              attach
              :items="item.values"
              v-model="inclusionItem.value1[0]"
              label="Select from"
              box
              style="padding-right: 10px;"
            />
          </v-flex>
          <v-flex xs12 sm6 v-if="inclusionItem.selectedOption === 'Range'">
            <v-autocomplete
              attach
              :items="item.values"
              v-model="inclusionItem.value2[0]"
              label="Select to"
              box
            />
          </v-flex>
          <v-flex xs12 sm6 v-if="inclusionItem.selectedOption === 'Increment'">
            <v-select
              attach
              :items="item.values"
              v-model="inclusionItem.value1"
              label="Select start"
              outline
              style="padding-right: 10px;"
            />
          </v-flex>
          <v-flex xs12 sm6 v-if="inclusionItem.selectedOption === 'Increment'">
            <v-select
              attach
              :items="item.values"
              v-model="inclusionItem.value2"
              label="Select Increment"
              outline
            />
          </v-flex>
        </v-flex>
        <v-flex xs12 v-if="inclusionItem.selectedOption === 'Last'">
          <v-text-field
            label="Last - L"
            outline
            v-model="inclusionItem.value1"
            :rules="[rules.required]"
          />
        </v-flex>
        <v-flex xs12 v-if="inclusionItem.selectedOption === 'Weekday'">
          <v-text-field
            label="Weekday - W"
            outline
            v-model="inclusionItem.value1"
            :rules="[rules.required]"
          />
        </v-flex>
        <v-flex xs12 v-if="inclusionItem.selectedOption === 'nth Day'">
          <v-text-field
            label="nth Day - #"
            outline
            v-model="inclusionItem.value1"
            :rules="[rules.required]"
          />
        </v-flex>
      </v-layout>
      <v-layout align-center fill-height v-if="inclusionItem.selectedOption">
        <div color="secondary">
          Tips...
        </div>
        <v-btn icon @click="showTip = !showTip">
          <v-icon
            >{{ showTip ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </v-btn>
      </v-layout>
      <v-layout class="row wrap" v-if="inclusionItem.selectedOption && showTip">
        <v-flex xs1>
          <v-icon color="secondary">help</v-icon>
        </v-flex>
        <v-flex xs11>
          <div
            class="caption text-lg-left "
            v-if="inclusionItem.selectedOption === 'Every'"
          >
            Tip: Option 'Every' is used to specify one or more values. * (“all
            values”) - used to select all values within a option. For example,
            “*” in the minute field means “every minute”.
            <blockquote>
              ? (“no specific value” - valid only for Day of month/Day or week
              option) - useful when you need to specify something in one of the
              two fields in which the character is allowed, but not the other.
              For example, if I want my trigger to fire on a particular day of
              the month (say, the 10th), but don’t care what day of the week
              that happens to be, I would put “10” in the day-of-month field,
              and “?” in the day-of-week field. See the examples below for
              clarification.
            </blockquote>
          </div>
          <div
            class="caption text-lg-left "
            v-if="inclusionItem.selectedOption === 'Range'"
          >
            Tip: Option 'Range' is used to specify ranges. For example, “From =
            10, To = 12” in the hour option means “the hours 10, 11 and 12”.
          </div>
          <div
            class="caption text-lg-left "
            v-if="inclusionItem.selectedOption === 'Increment'"
          >
            Tip: Option 'Increment' is used to specify increments. For example,
            “From = 0, Increment = 5” in the seconds option means “the seconds
            0, 15, 30, and 45”. And “From = 5, Increment = 15” in the seconds
            option means “the seconds 5, 20, 35, and 50”. ‘From = 1, Increment =
            3’ in the day-of-month field means “fire every 3 days starting on
            the first day of the month”.
          </div>
          <div
            class="caption text-lg-left "
            v-if="inclusionItem.selectedOption === 'Last'"
          >
            Tip: L (“Last”) - has different meaning in each of the two fields in
            which it is allowed. For example, the value “L” in the day-of-month
            option means “the last day of the month” - day 31 for January, day
            28 for February on non-leap years. If used in the day-of-week option
            by itself, it simply means “7” or “SAT”. But if used in the
            day-of-week field after another value, it means “the last xxx day of
            the month” - for example
            <kbd>6L</kbd>
            means “the last friday of the month”. You can also specify an offset
            from the last day of the month, such as
            <kbd>L-3</kbd> which would mean the third-to-last day of the
            calendar month. When using the ‘L’ option, it is important not to
            specify lists, or ranges of values, as you’ll get
            confusing/unexpected results.
            <blockquote>
              The 'L' and 'W' characters can also be combined in the
              day-of-month field to yield
              <kbd>LW</kbd>, which translates to *"last weekday of the month"*.
            </blockquote>
          </div>
          <div
            class="caption text-lg-left "
            v-if="inclusionItem.selectedOption === 'Weekday'"
          >
            Tip: W (“weekday”) - used to specify the weekday (Monday-Friday)
            nearest the given day. As an example, if you were to specify
            <kbd>15W</kbd> as the value for the day-of-month field, the meaning
            is: “the nearest weekday to the 15th of the month”. So if the 15th
            is a Saturday, the trigger will fire on Friday the 14th. If the 15th
            is a Sunday, the trigger will fire on Monday the 16th. If the 15th
            is a Tuesday, then it will fire on Tuesday the 15th. However if you
            specify <kbd>1W</kbd> as the value for day-of-month, and the 1st is
            a Saturday, the trigger will fire on Monday the 3rd, as it will not
            ‘jump’ over the boundary of a month’s days. The ‘W’ character can
            only be specified when the day-of-month is a single day, not a range
            or list of days.
            <blockquote>
              The 'L' and 'W' characters can also be combined in the
              day-of-month field to yield
              <kbd>LW</kbd>, which translates to *"last weekday of the month"*.
            </blockquote>
          </div>
          <div
            class="caption text-lg-left "
            v-if="inclusionItem.selectedOption === 'nth Day'"
          >
            Tip: # (nth Day) - used to specify “the nth” XXX day of the month.
            For example, the value of <kbd>6#3</kbd>
            in the day-of-week field means “the third Friday of the month” (day
            6 = Friday and
            <kbd>#3</kbd> = the 3rd one in the month). Other examples:
            <kbd>2#1</kbd> = the first Monday of the month and
            <kbd>4#5</kbd>
            = the fifth Wednesday of the month. Note that if you specify
            <kbd>#5</kbd> and there is not 5 of the given day-of-week in the
            month, then no firing will occur that month.
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'job-inclusion-item',
  props: {
    item: Object
  },
  data() {
    return {
      inclusionItem: null,
      showTip: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      inclusionTypes: [
        {
          type: 'Second',
          values: Array.apply(null, { length: 60 }).map(Number.call, Number),
          options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
        },
        {
          type: 'Minute',
          values: Array.apply(null, { length: 60 }).map(Number.call, Number),
          options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
        },
        {
          type: 'Hour',
          values: Array.apply(null, { length: 24 }).map(Number.call, Number),
          options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
        },
        {
          type: 'Day of month',
          values: Array(31)
            .fill()
            .map((_, idx) => 1 + idx),
          options: [
            { name: 'Every' },
            { name: 'Range' },
            { name: 'Increment' },
            { name: 'Last' },
            { name: 'Weekday' }
          ]
        },
        {
          type: 'Month',
          values: [
            'JAN',
            'FEB',
            'MAR',
            'APR',
            'MAY',
            'JUN',
            'JUL',
            'AUG',
            'SEP',
            'OCT',
            'NOV',
            'DEC'
          ],
          options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
        },
        {
          type: 'Day of week',
          values: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
          options: [
            { name: 'Every' },
            { name: 'Range' },
            { name: 'Increment' },
            { name: 'Last' },
            { name: 'Weekday' },
            { name: 'nth Day' }
          ]
        },
        {
          type: 'Year',
          values: Array(130)
            .fill()
            .map((_, idx) => 1970 + idx),
          options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
        }
      ]
    }
  },
  mounted() {
    this.inclusionItem = this.item
  },
  watch: {
    item() {
      this.inclusionItem = this.item
    },
    inclusionItem() {
      this.$emit('update:item', this.inclusionItem)
    }
  },
  methods: {
    handleInclusionItemDelete() {
      this.$emit('delete', this.inclusionItem)
    },
    handleCRONCompute() {
      this.$emit('compute')
    },
    inclusionTypeChanged(item) {
      if (item.selectedType) {
        let obj = this.inclusionTypes.find(x => x.type === item.selectedType)
        item.options = obj.options
        item.values = obj.values
      }
    },
    selectionSingleChanged(item) {
      if (item.value1 && item.values) {
        if (item.value1.length > 0 && item.value1.length < item.values.length) {
          item.selectIcon = 'indeterminate_check_box'
        }
      }
    },
    selectAll(item) {
      if (item.selectedOption) {
        if (item.value1 && item.value1.length === 0) {
          item.value1 = item.values.slice()
          item.selectIcon = 'close'
        } else {
          item.value1 = []
          item.selectIcon = 'check_box_outline_blank'
        }
      }
    }
  }
}
</script>
